const reports: { md: string; title: string; url: string; html: string }[] = [
  {
    md: '/reports/report-2024-02-22.md',
    title: '22 February 2024',
    url: 'https://doi.org/10.14279/depositonce-19869',
    html: '',
  },
  {
    md: '/reports/report-2023-11-13.md',
    title: '13 November 2023',
    url: 'https://doi.org/10.14279/depositonce-19016',
    html: '',
  },
  {
    md: '/reports/report-2023-09-14.md',
    title: '14 September 2023',
    url: 'https://doi.org/10.14279/depositonce-18603',
    html: '',
  },
  {
    md: '/reports/report-2023-06-16.md',
    title: '16 June 2023',
    url: 'https://doi.org/10.14279/depositonce-17851',
    html: '',
  },
  {
    md: '/reports/report-2023-02-27.md',
    title: '27 February 2023',
    url: 'https://doi.org/10.14279/depositonce-17034.2',
    html: '',
  },
  {
    md: '/reports/report-2022-12-02.md',
    title: '02 December 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-16561',
    html: '',
  },
  {
    md: '/reports/report-2022-10-24.md',
    title: '24 October 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-16377',
    html: '',
  },
  {
    md: '/reports/report-2022-08-09.md',
    title: '09 August 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-16079.2',
    html: '',
  },
  {
    md: '/reports/report-2022-06-28.md',
    title: '28 June 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-15928',
    html: '',
  },
  {
    md: '/reports/report-2022-04-26.md',
    title: '26 April 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-15525',
    html: '',
  },
  {
    md: '/reports/report-2022-03-22.md',
    title: '22 March 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-15347',
    html: '',
  },
  {
    md: '/reports/report-2022-02-23.md',
    title: '23 Feb 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-15237',
    html: '',
  },
  {
    md: '/reports/report-2022-01-20.md',
    title: '20 Jan 2022',
    url: 'http://dx.doi.org/10.14279/depositonce-14951',
    html: '',
  },
  {
    md: '/reports/report-2021-12-17.md',
    title: '17 Dec 2021',
    url: 'http://dx.doi.org/10.14279/depositonce-12856.2',
    html: '',
  },
  {
    md: '/reports/report-2021-11-19.md',
    title: '19 Nov 2021',
    url: 'http://dx.doi.org/10.14279/depositonce-12672',
    html: '',
  },
  {
    md: '/reports/report-2021-10-22.md',
    title: '22 Oct 2021',
    url: 'http://dx.doi.org/10.14279/depositonce-12510',
    html: '',
  },
  {
    md: '/reports/report-2021-09-24.md',
    title: '24 Sep 2021',
    url: 'https://dx.doi.org/10.14279/depositonce-12427',
    html: '',
  },
  {
    md: '/reports/report-2021-09-03.md',
    title: '03 Sep 2021',
    url: 'https://doi.org/10.14279/depositonce-12336',
    html: '',
  },
  {
    md: '/reports/report-2021-08-27.md',
    title: '27 Aug 2021',
    url: 'https://doi.org/10.14279/depositonce-12321',
    html: '',
  },
  {
    md: '/reports/report-2021-07-16.md',
    title: '16 July 2021',
    url: 'https://doi.org/10.14279/depositonce-12207.2',
    html: '',
  },
  {
    md: '/reports/report-2021-06-18.md',
    title: '18 June 2021',
    url: 'https://doi.org/10.14279/depositonce-12053',
    html: '',
  },
  {
    md: '/reports/report-2021-05-21.md',
    title: '21 May 2021',
    url: 'https://doi.org/10.14279/depositonce-11941',
    html: '',
  },
  {
    md: '/reports/report-2021-04-30.md',
    title: '30 April 2021',
    url: 'https://doi.org/10.14279/depositonce-11890',
    html: '',
  },
  {
    md: '/reports/report-2021-04-09.md',
    title: '09 April 2021',
    url: 'http://dx.doi.org/10.14279/depositonce-11772',
    html: '',
  },
  {
    md: '/reports/report-2021-03-19.md',
    title: '19 March 2021',
    url: 'https://doi.org/10.14279/depositonce-11678',
    html: '',
  },
  {
    md: '/reports/report-2021-02-26.md',
    title: '26 Feb 2021',
    url: 'https://doi.org/10.14279/depositonce-11486',
    html: '',
  },
  {
    md: '/reports/report-2021-02-05.md',
    title: '05 Feb 2021',
    url: 'http://dx.doi.org/10.14279/depositonce-11376',
    html: '',
  },
  {
    md: '/reports/report-2021-01-15.md',
    title: '15 Jan 2021',
    url: 'http://dx.doi.org/10.14279/depositonce-11289',
    html: '',
  },
  {
    md: '/reports/report-2020-12-18.md',
    title: '18 Dez 2020',
    url: 'http://dx.doi.org/10.14279/depositonce-11107',
    html: '',
  },
  {
    md: '/reports/report-2020-12-04.md',
    title: '04 Dez 2020',
    url: 'http://dx.doi.org/10.14279/depositonce-10988',
    html: '',
  },
  {
    md: '/reports/report-2020-11-13.md',
    title: '13 Nov 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10810',
    html: '',
  },
  {
    md: '/reports/report-2020-10-23.md',
    title: '23 Oct 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10662.2',
    html: '',
  },
  {
    md: '/reports/report-2020-10-02.md',
    title: '02 Oct 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10624.2',
    html: '',
  },
  {
    md: '/reports/report-2020-09-11.md',
    title: '11 Sep 2020',
    url: 'https://doi.org/10.14279/depositonce-10553',
    html: '',
  },
  {
    md: '/reports/report-2020-08-21.md',
    title: '21 Aug 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10480',
    html: '',
  },
  {
    md: '/reports/report-2020-07-24.md',
    title: '24 July 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10417',
    html: '',
  },
  {
    md: '/reports/report-2020-07-03.md',
    title: '03 July 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10373',
    html: '',
  },
  {
    md: '/reports/report-2020-06-19.md',
    title: '19 Jun 2020',
    url: 'https://doi.org/10.14279/depositonce-10335',
    html: '',
  },
  {
    md: '/reports/report-2020-06-05.md',
    title: '05 Jun 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10152',
    html: '',
  },
  {
    md: '/reports/report-2020-05-20.md',
    title: '20 May 2020',
    url: 'https://dx.doi.org/10.14279/depositonce-10085',
    html: '',
  },
  {
    md: '/reports/report-2020-05-07.md',
    title: '07 May 2020',
    url: 'https://doi.org/10.14279/depositonce-10018',
    html: '',
  },
  {
    md: '/reports/report-2020-04-24.md',
    title: '24 Apr 2020',
    url: 'https://doi.org/10.14279/depositonce-10017',
    html: '',
  },
  {
    md: '/reports/report-2020-04-08.md',
    title: '08 Apr 2020',
    url: 'https://doi.org/10.14279/depositonce-10016',
    html: '',
  },
]

export default reports
